module.exports = __webpack_public_path__ + "img/12.c5678720.webp";